module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/tv-screen-icon-7adf7cc849a9d73ff640b893a0ae3ee6.png";